import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";

const { transparent } = colors;

const textField = {
  defaultProps: {
    size: "small",
    variant: "outlined",
    InputLabelProps: { shrink: true },
  },
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",

      "& .MuiInputLabel-root": {
        position: "relative",
        transform: "none !important",
        maxWidth: "100%",
      },

      "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
      },

      "& .MuiOutlinedInput-root": {
        marginTop: 0,
      },

      "& .MuiFormHelperText-root": {
        marginLeft: 0,
        marginRight: 0,
        marginTop: pxToRem(4),
        lineHeight: 1.35,
        overflowWrap: "anywhere",
        fontSize: pxToRem(12),
      },
    },
  },
};

export default textField;
